import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'aid-insurance-type-item',
  template: `
    <div class="aid-layout-row aid-layout-align-start-center">
      @if (canCheck) {
        <mat-checkbox
          class="padding-right-32"
          [checked]="checked"
          [disabled]="disabled"
          color="primary"
          [indeterminate]="indeterminate"
          (change)="onChange()"
        >
        </mat-checkbox>
      }
      <div
        class="element full-width aid-layout-row aid-layout-align-space-between-center aid-layout-gap-32"
      >
        <div
          class="pointer element--name aid-layout-row aid-layout-align-start-center"
          (click)="onSelect()"
        >
          <div class="mat-subtitle-2 element--color">
            {{ name }}
          </div>
          @if (abbreviation) {
            <div class="mat-subtitle-2 padding-left-4">
              ({{ abbreviation }})
            </div>
          }
        </div>
        <div
          class="padding-right-32 aid-layout-row aid-layout-align-start-center aid-layout-gap-64"
        >
          <ng-content select="[aidInsuranceTypeItemCenter]"></ng-content>
          <ng-content select="[aidInsuranceTypeItemRight]"></ng-content>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./insurance-type-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InsuranceTypeItemComponent implements OnInit {
  @Input() name?: string;
  @Input() abbreviation?: string;
  @Input() canCheck = false;
  @Input() checked?: boolean;
  @Input() indeterminate = false;
  @Input() selected = false;
  @Input() disabled = false;

  @Output() change = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onChange() {
    this.change.emit();
  }

  onSelect() {
    if (this.disabled) {
      return;
    }
    this.change.emit();
  }
}
